import { usePortalAccess } from '../../components/PortalAccess';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';

const TABS = [
  { to: '/smm/dashboard', label: 'Обзор' },
  { to: '/smm/vk', label: 'VK' },
  { to: '/smm/telegram', label: 'TG' },
  { to: '/smm/instagram', label: 'Instagram' },
  { to: '/smm/max', label: 'Макс' },
];

export default function SmmAppLayout() {
  const navigate = useNavigate();
  const { permissions } = usePortalAccess();
  const location = useLocation();
  const basePath = location.pathname.startsWith('/admin/smm') ? '/admin/smm' : '/smm';
  const backPath = basePath === '/admin/smm' ? '/admin/dashboard' : '/app';

  return (
    <div className="smm-standalone-shell" style={{ minHeight: '100vh', background: '#111827', color: '#f8fafc' }}>
      <div style={{
        background: '#111827',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        padding: '8px 12px 0',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <button
          onClick={() => navigate(backPath)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, padding: '0 4px', color: 'rgba(226,232,240,0.72)', flexShrink: 0 }}
        >
          ←
        </button>
        <div style={{ display: 'flex', gap: 0, flex: 1, overflowX: 'auto', scrollbarWidth: 'none' }}>
          {TABS.filter(tab => permissions[`smm.${tab.to.endsWith('dashboard') ? 'overview' : tab.to.split('/').pop()}`]).map(tab => (
            <NavLink
              key={tab.to}
              to={`${basePath}${tab.to.slice(4)}`}
              style={({ isActive }) => ({
                padding: '8px 14px',
                fontSize: 13,
                fontWeight: 500,
                textDecoration: 'none',
                borderBottom: isActive ? '2px solid #60a5fa' : '2px solid transparent',
                color: isActive ? '#60a5fa' : 'rgba(226,232,240,0.72)',
                whiteSpace: 'nowrap',
              })}
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>
      <div style={{ padding: '12px 12px 20px', background: '#111827' }}><Outlet /></div>
    </div>
  );
}
